import React from 'react'

export default ({ children }) => (
  <div style={{ maxWidth: 1180, margin: '0 auto', paddingBottom:'25'}}>
    {children}
    <footer className="wrapper">Copyright &copy; 2020 Coffee In Code Out Development, LLC <div>Find us on <a href={"https://www.facebook.com/CoffeeInCodeOutDevelopment"} target={"_new"}>Facebook</a> or <a href={"https://twitter.com/CoffeeInDevLLC"} target={"_new"}>Twitter</a></div></footer>
  </div>
)
